<template>
    <div class="action-notice-send-join-profile">
        <div class="title f-bold" v-html="$translate('ACTION_NOTICE_SEND_JOIN_PROFILE_TITLE')" />
        <div class="body">
            <div v-html="body" />
        </div>
    </div>
</template>
<script>
export default {
    name: 'ActionNoticeSendJoinProfile',
    props: ['message'],
    computed: {
        chat() {
            return this.$store.getters.chat
        },
        chatUser() {
            if (!this.chat) return

            return (this.chat || {}).user
        },
        body() {
            const body = this.$translate('ACTION_NOTICE_SEND_JOIN_PROFILE_BODY')
            return body
        },
    },
}
</script>
